<template>
  <div class="container">
    <div class="personal">
      <div class="coverWork-tab">自荐作品</div>
      <div class="hr"></div>
      <div class="other-info">
        <div class="other">
          <span class="redStart">*</span>
          <span class="name">作品名称</span>
          <el-input v-model="nameWork" class="inputName" placeholder="请输入作品名称"></el-input>
        </div>
        <div class="other">
          <span class="redStart">*</span>
          <span class="name material">材 质</span>
          <el-input v-model="material" class="inputName" placeholder="请输入材质"></el-input>
        </div>
        <div class="other">
          <span class="name process">工 艺</span>
          <el-input v-model="process" class="inputName" placeholder="请输入工艺名称"></el-input>
        </div>
        <div class="other">
          <span class="name mosaic">镶 嵌</span>
          <el-input v-model="mosaic" class="inputName" placeholder="请输入镶嵌名称"></el-input>
        </div>
        <div class="other">
          <span class="name style">风 格</span>
          <el-input v-model="style" class="inputName" placeholder="请输入作品风格"></el-input>
        </div>
        <div class="other">
          <span class="name jewelryType">首饰类型</span>
          <el-input v-model="jewelryType" class="inputName" placeholder="请输入首饰类型"></el-input>
        </div>
        <div class="otherPdf">
          <span class="redStart">*</span>
          <span class="name uploading">上传作品<span class="pdfFormat">（pdf格式，限定2M）</span></span>
          <span class="downloadTemplate" @click="uploadTemplate">下载模板</span>
          <div class="pic"  style="margin-bottom: 30px;"  @click="selectFile()">
            <img class="user-img" src="../../../static/image/coverWork/upload.png" alt/>
          </div>
           <input :type="inputType" id="fileName" @change="uploading($event)" style="display: none" accept=".pdf" />
          <div style="margin-top: 10px;font-size: 14px;color: #3A3A3A;margin-left: 10px;display: flex;align-items: center;"
            v-for="(item2,index2) in pdfList">
            {{item2.fileName}}
            <img src="../../../static/image/close.svg" alt="" style="width: 20px;margin-left: 10px;" @click="deletePdf(index2)">
          </div>
        </div>
        <!-- 激活邮箱弹窗 -->
        <el-dialog title="提示" :visible.sync="isActivation" width="30%" :before-close="handleClose">
          <span v-if='!isTrue2'>您的邮箱或银行卡未认证，是否现在认证？</span>
          <p v-if="isTrue2" style="text-align: center;font-weight: bold;margin-bottom: 25px;font-size: 20px;">请填写认证信息</p>
          <p v-if="isTrue2&&status.emailStatus==0" style="display: flex;align-items: center;">
            <span style="color: #FF0000;">*</span>邮箱：<el-input v-model="missionInfo.email" placeholder="请输入邮箱" style="width: 80%;margin-left: 28px;"></el-input>
          </p>
          <div v-if="status.infoCompleteStatus==0 && isTrue2">
            <p v-if="isTrue2" style="display: flex;align-items: center;">
              <span style="color: #FF0000;">*</span>银行卡号：<el-input v-model="missionInfo.bankNumber" placeholder="请输入银行卡号"
                style="width: 80%;"></el-input>
            </p>
            <p v-if="isTrue2" style="display: flex;align-items: center;">
              <span style="color: #FF0000;">*</span>开户银行：<el-input v-model="missionInfo.bankName" placeholder="请输入开户银行"
                style="width: 80%;" maxlength="10"></el-input>
            </p>
            <p v-if="isTrue2" style="display: flex;align-items: center;">
              <span style="color: #FF0000;">*</span>开户省市：<el-input v-model="missionInfo.bankBranch" placeholder="请输入开户省市"
                style="width: 80%;" maxlength="20"></el-input>
            </p>
            <p v-if="isTrue2" style="display: flex;align-items: center;">
              <span style="color: #FF0000;">*</span>开户人姓名：<el-input v-model="missionInfo.accountName" placeholder="请输入开户人姓名"
                style="width: 78%;" maxlength="10"></el-input>
            </p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isActivation = false">取 消</el-button>
            <el-button @click="goActive" v-if='!isTrue2'>去认证</el-button>
            <el-button @click="ConfirmActive" v-if="isTrue2">确认认证</el-button>
          </span>
        </el-dialog>
        <button class="submitAudit" @click="goSubmit">提交审核</button>
      </div>
    </div>
  </div>
</template>

<script>
  import config from "../../api/config";
  import manage from "../../api/manage";
  export default {
    name: "coverWork",
    data() {
      return {
        isTrue2: false,
        isActivation: false, //激活邮箱弹窗
        missionInfo: [],
        baseImgUrl: config.baseImgUrl, //拼接地址
        imageUrl: '', //图片地址
        nameWork: '', //作品名称
        material: '', //材质
        process: '', //工艺
        mosaic: '', //镶嵌
        style: '', //风格
        jewelryType: '', //首饰类型
        pdfUrl: [], //上传作品
        message: '',
        pdfList: [], //上传多个pdf对象
        inputType: 'file',
        status:{},
      }
    },
    created() {
      // 获取存的用户信息
      this.getDetails();
    },
    methods: {
      async getDetails() { //获取保存数据
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        try {
          const res = await this.$http.getDetails(userInfo.id)
          console.log(res)
          if (res.code == 200) {
            this.missionInfo = res.result
          } else {
            this.$message(res.message);
          }
        } catch (e) {

          throw e
        }
      },
      goActive() { //去激活
        this.isTrue2 = true
      },
      ConfirmActive() {
        // this.isActivation = false
        this.getEmail()
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      async getEmail() { //激活邮箱
        let data = {
          id: this.missionInfo.id,
          name: this.missionInfo.name,
          email: this.missionInfo.email,
          bankNumber: this.missionInfo.bankNumber,
          bankName: this.missionInfo.bankName,
          bankBranch: this.missionInfo.bankBranch,
          accountName: this.missionInfo.accountName,
          emailStatus: this.missionInfo.emailStatus,
          infoCompleteStatus: this.missionInfo.infoCompleteStatus,
        }
        if (this.missionInfo.email != '' && this.missionInfo.bankNumber != '' && this.missionInfo.bankName != '' &&
          this.missionInfo.bankBranch != '' && this.missionInfo.accountName != '') {
          const res = await this.$http.getEmail(data)
          if (res.code == 200) {
              this.isActivation = false
              this.$message.success(res.result)
          } else {
            this.isActivation = true
            this.$message.warning(res.message != "" ? res.message : '提交失败', 1500);
          }
        }else{
          this.isActivation = true
          this.$message.warning("请填写必填项")
        }
      },
      deletePdf(index2) { //删除pdf
        this.pdfList.splice(index2, 1)
      },
      // 下载pdf模板
      async uploadTemplate() {
        try {
          let data = {}
          let fileName = '作品模板.pdf';
          const res = await manage.downloadFile(this.$http.uploadTemplateUrl(), fileName, data)
        } catch (e) {
          this.$message(e.data ? e.data.message : e.message);
          throw e
        }
      },
      async selectFile() {
        const res = await this.$http.getEmailStatus()
        this.status = res.result
        if (res.result.emailStatus == 0 || res.result.infoCompleteStatus == 0) { //未激活要先激活
          this.isActivation = true
        } else {
          this.isActivation = false
          document.getElementById("fileName").click();
        }

      },
      // 上传作品
      async uploading(event) {
        console.log('上传')
        let file = event.target.files[0];
        let fileName = file.name;
        let fileSize = file.size;
        if (fileName.indexOf(".pdf") == -1) {
          this.$message.error('文件格式必须为pdf！', 2000)
          document.getElementById("fileName").value = ""
          return false;
        }
        if (fileName.length > 50) {
          this.$message.error('文件名称过长，请求改！', 2000)
          document.getElementById("fileName").value = ""
          return false;
        }
        if (fileSize > 1024 * 1024 * 2) {
          this.$message.error('上传文件大小不能超过2M！', 2000)
          document.getElementById("fileName").value = ""
          return false;
        }
        let data = {
          biz: 'temp',
          file: fileName
        }

        let formData = new FormData()
        formData.append('fileName', fileName)
        formData.append('file', file)
        console.log(fileName)
        console.log(file)
        let res = await manage.uploadAction('/api/common/upload', formData)
        this.message = res.data.message
        // console.log(message)
        let obj = {
          "fileName": fileName,
          "pdfUrl": res.data.message,
          "size": fileSize
        }
        this.pdfList.push(obj)
        // this.pdfUrl.push(fileName)
        // console.log(this.pdfUrl)
        if (res.data.code == 200) {
          this.$message.success('上传成功', 1000)
          if (document.getElementById("fileName") != null) { //可以上传同名pdf文件
            document.getElementById("fileName").value = ""
          }
          this.imageUrl = res.data.message;
          console.log(this.imageUrl, this.baseImgUrl, res.data.message)
        } else {
          this.$message.error(res.message, 1000)
        }
      },

      async goSubmit() {
        try {
          let data = {
            name: this.nameWork,
            material: this.material,
            technique: this.process,
            inset: this.mosaic,
            style: this.style,
            jewelryType: this.jewelryType,
            workInfoVoList: this.pdfList, //多个pdf
            // pdfUrl: this.pdfUrl
          }

          if (this.nameWork && this.material && this.pdfList.length > 0) {
            // console.log(this.nameWork)
            // console.log(this.material)
            console.log(this.pdfList)
            const res = await this.$http.selfRecommendedWorks(data)
            console.log(res)
            this.$message.success(res.result);

            // 提交审核成功清空数据
            this.nameWork = '' //作品名称
            this.material = '' //材质
            this.process = '' //工艺
            this.mosaic = '' //镶嵌
            this.style = '' //风格
            this.jewelryType = '' //首饰类型
            this.pdfList = [] //上传多个pdf对象
          } else {
            // alert('请输入必填项')
            this.$message.warning("请输入必填项");
          }

        } catch (e) {
          throw e;
        }
      },
    },
  }
</script>

<style scoped>
  .other>>>.el-input__inner {
    border: 0;
    border-radius: 0;
    height: 30px;
    border-bottom: 1px solid #9E9E9E;
  }

  .container {
    width: 900px;
    background-color: #FFFFFF;

  }

  .coverWork-tab {
    width: 66px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 22px;
    color: #3A3A3A;
    line-height: 64px;
    margin: 0 45px;
  }

  .personal {
    width: 100%;
    height: 64px;
    border-bottom: 1px solid #C7C7C7;
  }

  .other-info {
    padding: 37px 0px 0 45px;
    /* background-color: peachpuff; */
  }

  .other {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    /* background-color: pink; */
  }

  .redStart {
    color: red;
    margin-right: 10px;
  }

  .name {
    width: 58px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #3A3A3A;

    margin-right: 95px;
  }

  .inputName {
    width: 300px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 18px;
    color: #C7C7C7;
  }

  .material {
    letter-spacing: 5px;
    /* margin-right: 114px; */
  }

  .process,
  .mosaic,
  .style {
    margin-left: 16px;
    letter-spacing: 5px;
    /* margin-right: 114px; */
  }

  .jewelryType {
    margin-left: 16px;
  }

  .uploading {
    width: 200px;
    margin-right: 0;
  }

  .pdfFormat {
    width: 186px;
    height: 20px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 17px;
    color: #3A3A3A;

  }

  .downloadTemplate {
    /* width: 64px; */
    height: 16px;
    font-size: 10px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 14px;
    color: #658FFF;
    border-bottom: 1px solid #658FFF;
  }

  .pic {
    position: relative;
    top: 15px;
    left: 14px;
    width: 79px;
    height: 79px;
    background: #F7F7F7;
  }

  .user-img {
    position: absolute;
    width: 29px;
    height: 26px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .submitAudit {
    width: 115px;
    height: 39px;
    background-color: #DFB876;
    border-radius: 20px;
    font-size: 15px;
    color: #FFFFFF;
    border: none;
    outline: none;
    margin-top: 30px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/coverWork/coverWork.vue